import React from "react"
import { HiPlay } from "react-icons/hi"
import { Image } from "react-bootstrap"
import { classNames } from "../../../../helpers/classNames"
import type { VideoData } from "../../../../constants/types"

type GuideVideoThumbnailProps = {
  data: VideoData
  list: boolean
  preview: boolean
  onClick?: (data: VideoData) => void
}

export const GuideVideoThumbnail: React.FC<GuideVideoThumbnailProps> = ({ data, list, preview, onClick }) => {
  const classes = classNames({
    "image-container": true,
    "position-relative": true,
    list,
    preview
  })

  return (
    <div className={classes} onClick={() => onClick?.(data)}>
      <Image src={data.thumbnail ?? undefined} />
      <HiPlay className="position-absolute video-play-button" />
    </div>
  )
}
